import { mutate, apolloClient } from '../../../../../../../../common/graphql';
import {
  LEADERBOARD_SCORES_QUERY,
  DELETE_LEADERBOARD_SCORE_MUTATION,
  LeaderboardScoresData,
  UserLeaderboardScoresInput,
  DeleteUserLeaderboardScoreInput,
  DeleteUserLeaderboardScoreMutation,
  ApproveFlaggedLeaderboardScoreInput,
  ApproveFlaggedLeaderboardScoreMutation,
  APPROVE_FLAGGED_LEADERBOARD_SCORE_MUTATION,
} from '@crazygames/graph-types/game/leaderboard-scores.type';

export function fetchLeaderboardScores(submissionId: string, input: UserLeaderboardScoresInput) {
  return apolloClient.query<LeaderboardScoresData>({
    query: LEADERBOARD_SCORES_QUERY,
    variables: { submissionId, input },
    fetchPolicy: 'network-only',
  });
}

export function deleteLeaderboardScore(input: DeleteUserLeaderboardScoreInput) {
  return mutate<DeleteUserLeaderboardScoreInput, DeleteUserLeaderboardScoreMutation>(DELETE_LEADERBOARD_SCORE_MUTATION, input);
}

export function developerApproveFlaggedLeaderboardScore(input: ApproveFlaggedLeaderboardScoreInput) {
  return mutate<ApproveFlaggedLeaderboardScoreInput, ApproveFlaggedLeaderboardScoreMutation>(
    APPROVE_FLAGGED_LEADERBOARD_SCORE_MUTATION,
    input,
  );
}
